import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styled, { StyledFunction } from 'styled-components';
import { MenuList } from './MenuList';
import { standardCurveTiming, standardDuration } from '../../sharedStyle/animation';
import { elevation8 } from '../../sharedStyle/elevation';

interface IProps {
  isOpen: boolean;
}

interface IState {
  top: number;
}

const StyledDiv: StyledFunction<IProps & IState & React.HTMLProps<HTMLDivElement>> = styled.div;
const StyledMenu = StyledDiv`
  display: inline-block;
  min-width: 170px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - ${props => props.top}px - 28px - 100px);
  height: ${props => (props.isOpen ? '100%' : '0')};
  transform-origin: 0px 0px 0px;
  transform: ${props => (props.isOpen ? 'scale(1, 1)' : 'scale(1, 0)')};
  transition: height ${standardDuration} ${standardCurveTiming};
  overflow-x: hidden;
  overflow-y: auto;
  will-change: transform;
  z-index: 1;
  pointer-events: auto;
  ${elevation8};
`;

export class Menu extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      top: 0,
    };
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (this.props.isOpen === false && nextProps.isOpen === true) {
      const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
      this.setState({ top: rect.top });
    }
  }

  public render() {
    return (
      <StyledMenu top={this.state.top} isOpen={this.props.isOpen}>
        <MenuList>{this.props.children}</MenuList>
      </StyledMenu>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Menu/Menu.tsx